import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Firebase SDK import
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBQ3jdYK0YlpjuY0JH3AWoo6r-DIcI_l4I",
  authDomain: "dev-safelet.firebaseapp.com",
  databaseURL: "https://dev-safelet-default-rtdb.firebaseio.com",
  projectId: "dev-safelet",
  storageBucket: "dev-safelet.firebasestorage.app",
  messagingSenderId: "589008625602",
  appId: "1:589008625602:web:8486a22ce29e0feadf005b",
  measurementId: "G-ECJRXYLCR5"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

const requestNotificationPermission = () => {
  Notification.requestPermission().then(permission => {
    if (permission === 'granted') {
      console.log("Notification permission granted.");
      
      getToken(messaging, { vapidKey: 'BMeFuAMvVf-eXx_NmNPKlLtccS2mSl0Xo0XLMILPowfm2ZB_jMGEEdsySJ5O2rWQLdRy1evvgt_rquBJ6IKyR_o' })
        .then((currentToken) => {
          if (currentToken) {
            console.log("FCM Token: ", currentToken);
          } else {
            console.log("No token available. Request permission to generate one.");
          }
        })
        .catch((err) => {
          console.log("An error occurred while retrieving the token. ", err);
        });
    } else {
      console.log("Notification permission denied.");
    }
  }).catch(err => {
    console.error("Error requesting notification permission: ", err);
  });
};

onMessage(messaging, (payload) => {
  console.log('Foreground notification received: ', payload);
  const { title, body } = payload.notification;
  
  new Notification(title, {
    body: body,
    icon: '/firebase-logo.png'
  });
});

requestNotificationPermission();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
